import React, { useEffect, useRef, useState } from 'react';
import { useWallet } from '@solana/wallet-adapter-react';
import { callDigitalAssets, formatAtomic } from '../utils/digitalAssetsClient';

export default function DigitalAssetOfferManagement({ offer, disabled = false }) {
    const wallet = useWallet();
    const [busy, setBusy] = useState(false);
    const [message, setMessage] = useState('');
    const [priceAmount, setPriceAmount] = useState(() => formatAtomic(offer.priceAtomic, offer.paymentDecimals));
    const dirty = useRef(false);
    useEffect(() => {
        if (!dirty.current) setPriceAmount(formatAtomic(offer.priceAtomic, offer.paymentDecimals));
    }, [offer.priceAtomic, offer.paymentDecimals]);
    const manage = async (action, payload) => {
        try {
            setBusy(true); setMessage('');
            await callDigitalAssets(action, { offerId: offer.id, ...payload }, wallet);
            if (action === 'updateOfferPrice') dirty.current = false;
            setMessage(action === 'updateOfferPrice' ? 'Future sale price updated.' : 'Mint availability updated.');
        } catch (error) { setMessage(error.message); } finally { setBusy(false); }
    };
    return <div>
        <p>{offer.name} - {offer.status} - {offer.mintedCount}{offer.editionMode === 'OPEN' ? ' minted (open edition)' : '/' + offer.supply + ' minted'}</p>
        <button type="button" className="muulti-button" disabled={disabled || busy || !!offer.activeOperationId}
            onClick={() => manage('setOfferStatus', { status: offer.status === 'PAUSED' ? 'PUBLISHED' : 'PAUSED' })}>
            {offer.status === 'PAUSED' ? 'Resume offer' : 'Pause offer'}
        </button>
        <label>Future sale price (SOL)<input className="muulti-input" inputMode="decimal" value={priceAmount}
            onChange={event => { dirty.current = true; setPriceAmount(event.target.value); }} /></label>
        <button type="button" className="muulti-button"
            disabled={disabled || busy || !!offer.activeOperationId || offer.archiveStatus === 'ARCHIVING'}
            onClick={() => manage('updateOfferPrice', { priceAmount })}>Update sale price</button>
        {message && <p role="status">{message}</p>}
    </div>;
}
